import React, { Fragment } from "react";

import { PropTypes } from "prop-types";

import { Grid, Typography, Box, Link } from "@mui/material";
import Typographies from "./Typographies";
import {
  internetHeader,
  internetTexts,
} from "../../../shared/constants/internet";

export default function InternetInstructions({ location }) {
  const typographyContext = {
    keys: {
      "internet-credentials": location.impulsclient_set.map((c) => (
        <Box key={`client-creds-box-${c.serial}`} marginY={1}>
          <Typography>
            SSID: impuls-{c.serial[6]}
            {c.serial[1]}
            {c.serial[3]}
          </Typography>
          <Typography>Passwort: {c.serial}</Typography>
        </Box>
      )),
      "navigate-to-webpage": (
        <Typography component="ul">
          <Typography component="li">
            Option 1: Scannen Sie folgenden QR-Code:
            <br />
            <img
              src={"/instructions/qr_impuls_local_white.svg"}
              alt="QR-Code"
              style={{
                marginBottom: "20px",
                marginTop: "20px",
                maxWidth: "100px",
              }}
            />
          </Typography>
          <Typography component="li">
            Option 2: Nutzen Sie folgenden Link:{" "}
            <Link
              href={"http://10.41.0.1:8080"}
              sx={{
                textDecoration: "none",
                "&:hover": { color: "secondary.main" },
              }}
            >
              http://10.41.0.1:8080
            </Link>
          </Typography>
        </Typography>
      ),
    },
  };

  return (
    <Fragment>
      <Grid container justify="center">
        <Grid
          key="internet-connection-instructions"
          xs={12}
          sm={12}
          md={12}
          item
          justifyContent="center"
          alignItems="center"
          marginY={3}
        >
          <Typography align="center" fontSize="h6.fontSize" color="secondary">
            {internetHeader}
          </Typography>
          <Box sx={{ height: 10 }} />
          <Typographies
            typographyData={internetTexts}
            context={typographyContext}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}

InternetInstructions.propTypes = {
  location: PropTypes.object,
};
